var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8272 3.86039C1.5 4.23283 1.5 4.8714 1.5 6.14854V13.1935C1.5 14.098 1.5 14.5502 1.73595 14.8907C1.97189 15.2312 2.38441 15.3742 3.20943 15.6602L4.18007 15.9967C4.70577 16.179 5.11028 16.3192 5.44975 16.4095C5.6712 16.4684 5.875 16.2946 5.875 16.0654V4.70282C5.875 4.51613 5.73723 4.35858 5.55627 4.31268C5.26435 4.23863 4.91345 4.11697 4.43251 3.95024C3.26757 3.54637 2.6851 3.34444 2.24191 3.5495C2.08456 3.62231 1.94337 3.72815 1.8272 3.86039Z",
    fill: "url(#paint0_linear_5099_11710)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46529 2.61096L8.31331 3.40971C7.89656 3.69868 7.59114 3.91045 7.33032 4.06143C7.20671 4.13298 7.125 4.26243 7.125 4.40525V15.6904C7.125 15.9684 7.41298 16.1419 7.64712 15.9921C7.89842 15.8314 8.18617 15.6319 8.53471 15.3902L9.68669 14.5915C10.1034 14.3025 10.4089 14.0907 10.6697 13.9397C10.7933 13.8682 10.875 13.7387 10.875 13.5959V2.31072C10.875 2.03278 10.587 1.85924 10.3529 2.00902C10.1016 2.16977 9.81382 2.3693 9.46529 2.61096Z",
    fill: "url(#paint1_linear_5099_11710)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7906 2.34094L13.8199 2.00444C13.2942 1.82217 12.8897 1.68195 12.5503 1.59165C12.3288 1.53274 12.125 1.70657 12.125 1.93572V13.2983C12.125 13.485 12.2628 13.6426 12.4437 13.6885C12.7356 13.7625 13.0866 13.8842 13.5675 14.0509C14.7324 14.4548 15.3149 14.6567 15.7581 14.4517C15.9154 14.3789 16.0566 14.273 16.1728 14.1408C16.5 13.7683 16.5 13.1298 16.5 11.8526V4.80766C16.5 3.90317 16.5 3.45093 16.2641 3.11045C16.0281 2.76998 15.6156 2.62697 14.7906 2.34094Z",
    fill: "url(#paint2_linear_5099_11710)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5099_11710",
    x1: 9.9728,
    y1: 1.58008,
    x2: 9.9728,
    y2: 16.4211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5099_11710",
    x1: 9.9728,
    y1: 1.58008,
    x2: 9.9728,
    y2: 16.4211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5099_11710",
    x1: 9.9728,
    y1: 1.58008,
    x2: 9.9728,
    y2: 16.4211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyMap);
export default __webpack_public_path__ + "static/media/daily-map.50b9b37b943f5a9e5e8a06cd63acd159.svg";
export { ForwardRef as ReactComponent };